var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningPop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 37.694,
    viewBox: "0 0 40 37.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8e8e8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -14.759)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.759)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.169,43.6,25.039,17.627a5.86,5.86,0,0,0-10.078,0L.832,43.6A5.857,5.857,0,0,0,5.87,52.453H34.13A5.858,5.858,0,0,0,39.169,43.6ZM20,47.765a2.344,2.344,0,1,1,2.344-2.344A2.347,2.347,0,0,1,20,47.765Zm2.344-9.375a2.344,2.344,0,1,1-4.688,0V26.672a2.344,2.344,0,1,1,4.688,0Z",
    transform: "translate(0 -14.759)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPop);
export default __webpack_public_path__ + "static/media/warningPop.3d5462a602b0cd88e92975e1ef0e2068.svg";
export { ForwardRef as ReactComponent };